import React from 'react';
import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import packageJson from '../../package.json';
import GLOBALS from '../config/globals';
import { serverVersionAtom } from '../api/axios';

function Footer() {
    const serverVersion = useAtomValue(serverVersionAtom);

    return (
        <footer>
            <div className="footer-links">
                <Link to="/about">About</Link>
                <Link to="/faq">FAQ</Link>
                <Link to="/version-history">Version History</Link>
                <a href={GLOBALS.DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer">Discord</a>
                <a href="https://www.etsy.com/shop/ThirdDanArt" target="_blank" rel="noopener noreferrer">Store</a>
            </div>
            <span>© 2024-2026 URANIUM LLC. All rights reserved.</span>
            <span>v{packageJson.version}{serverVersion ? ` · API ${serverVersion}` : ''}</span>
        </footer>
    );
}

export default Footer;
